import { useEffect, useRef, useState } from "react";
import { Expand, ExternalLink } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { RosaryFocusView } from "./RosaryFocusView";
import { openRosaryWindow } from "@/lib/rosarySession";
import { lenisRef } from "@/lib/nav";

export const RosaryLargeViews = ({ controller }) => {
  const [open, setOpen] = useState(false);
  const [blocked, setBlocked] = useState(false);
  const trigger = useRef(null);
  useEffect(() => {
    if (!open) return;
    const lenis = lenisRef.current;
    lenis?.stop();
    return () => { lenis?.start(); };
  }, [open]);
  return <div className="rosary-large-actions" data-testid="rosary-large-actions">
    <button ref={trigger} type="button" onClick={() => { controller.pause(); setOpen(true); }} data-testid="rosary-fullscreen-trigger"><Expand size={21} aria-hidden="true" /><span>Full-screen Rosary</span></button>
    <button type="button" onClick={() => setBlocked(!openRosaryWindow())} data-testid="rosary-popout-trigger"><ExternalLink size={21} aria-hidden="true" /><span>Open large Rosary window</span></button>
    {blocked && <p role="alert" data-testid="rosary-popup-blocked">The browser blocked the new window. <button type="button" onClick={() => setOpen(true)} data-testid="rosary-popup-fallback">Open full-screen here</button></p>}
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="rosary-fullscreen-dialog" data-testid="rosary-fullscreen-modal" onCloseAutoFocus={(event) => { event.preventDefault(); trigger.current?.focus({ preventScroll: true }); }}>
        <DialogTitle className="sr-only" data-testid="rosary-fullscreen-title">Large Rosary</DialogTitle>
        <DialogDescription className="sr-only" data-testid="rosary-fullscreen-description">The current prayer and Rosary beads.</DialogDescription>
        <RosaryFocusView controller={controller} onClose={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  </div>;
};